import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapLocationDot, faBus } from "@fortawesome/free-solid-svg-icons";

const terminal = [
  {
    nombre: "Terminal de Ómnibus",
    link: "https://maps.app.goo.gl/ZXVQPKDQuzR3YHox8",
    direccion: <>Leandro N. Alem 100.</>,
  },
  {
    nombre: "Boletería Oliva Córdoba – Coata",
    link: "https://maps.app.goo.gl/wYrL1CUXmyCCmACD7",
    direccion: (
      <>
        Leandro N. Alem 100.<br />
        Celular: 03532-15408957
      </>
    ),
  },
  {
    nombre: "Boletería Oliva Lep",
    link: "https://maps.app.goo.gl/wYrL1CUXmyCCmACD7",
    direccion: (
      <>
        Leandro N. Alem 100.<br />
        03532-15409034<br />
        03532-15417200
      </>
    ),
  },
];

const TerminalOmnibus = () => (
  <div className="content-tab">
    <div className="row">
      <div className="col-12 col-md-6">
        <h5>
          <FontAwesomeIcon icon={faBus} style={{ color: "#2980b9", marginRight: 8 }} />
          Terminal de Ómnibus
        </h5>
        <ul className="lista-referencias">
          {terminal.map((item, i) => (
            <li key={i}>
              <FontAwesomeIcon icon={faMapLocationDot} style={{ color: "#2980b9", marginRight: 8 }} />
              <a href={item.link} target="_blank" rel="noopener noreferrer">
                {item.nombre}
              </a>
              <div className="ms-2 me-auto">{item.direccion}</div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);

export default TerminalOmnibus;